<template>
  <div class="home">
    <!--<pre class="has-text-left">{{ $ajax.getUser().valueOf() }}</pre>-->

    <HomeBrandAmbassador
      v-if="$ajax.getUserRole().isBrandAmbassador"
    ></HomeBrandAmbassador>
    <HomePromoter v-else-if="$ajax.getUserRole().isPromoter"></HomePromoter>
    <HomePromoter v-else-if="$ajax.getUserRole().isClient"></HomePromoter>
    <HomeAdministrator
      v-else-if="$ajax.getUserRole().id == 1"
    ></HomeAdministrator>
    <div v-else-if="$ajax.getUserRole().isViewer">Promoters platform</div>
    <div v-else>
      <pre class="has-text-left">{{ $ajax.getUserRole() }}</pre>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeAdministrator from "../components/HomeAdministrator";
import HomeBrandAmbassador from "../components/HomeBrandAmbassador";
import HomePromoter from "../components/HomePromoter";
import router from "../router.js";

export default {
  name: "home",
  components: { HomeAdministrator, HomeBrandAmbassador, HomePromoter },
  created() {
    if (!this.$ajax.getUser().valueOf()) router.push({ name: "login" });
  },
};
</script>
